import initialState from './initialState';
import {
  FETCH_SL_ADMIN_ACCOUNTS_SUCCESS,
  FETCH_SL_ADMIN_ACCOUNTS_FAILURE,
  FETCH_SL_ACCOUNTS_SUCCESS,
  FETCH_SL_ACCOUNTS_FAILURE,
  FETCH_SL_VIEWS_SUCCESS,
  FETCH_SL_VIEWS_FAILURE,
  FETCHING_INITIAL_DATA_FOR_ADD_EDIT_MODAL,
  FETCHING_INITIAL_DATA_FOR_ADD_EDIT_MODAL_FINISHED,
  FETCH_SL_ADMIN_ACCOUNTS,
} from './types';

const slAccountsPageReducer = (state = initialState, { type, ...payload }) => {
  switch (type) {
    case FETCH_SL_ADMIN_ACCOUNTS:
      return {
        ...state,
        slAdminAccountsLoading: true,
      };
    case FETCH_SL_ADMIN_ACCOUNTS_SUCCESS:
      return {
        ...state,
        slAdminAccounts: payload.slAdminAccounts,
        slAdminAccountsLoading: false,
      };
    case FETCH_SL_ADMIN_ACCOUNTS_FAILURE:
      return {
        ...state,
        slAdminAccounts: initialState.slAdminAccounts,
        slAdminAccountsLoading: false,
      };
    case FETCH_SL_ACCOUNTS_SUCCESS:
      return {
        ...state,
        slAccounts: payload.slAccounts,
      };
    case FETCH_SL_ACCOUNTS_FAILURE:
      return {
        ...state,
        slAccounts: initialState.slAccounts,
      };
    case FETCH_SL_VIEWS_SUCCESS:
      return {
        ...state,
        slViews: payload.slViews,
      };
    case FETCH_SL_VIEWS_FAILURE:
      return {
        ...state,
        slViews: initialState.slViews,
      };
    case FETCHING_INITIAL_DATA_FOR_ADD_EDIT_MODAL:
      return {
        ...state,
        isFetchingInitialDataForAddAndEditModal: true,
      };
    case FETCHING_INITIAL_DATA_FOR_ADD_EDIT_MODAL_FINISHED:
      return {
        ...state,
        isFetchingInitialDataForAddAndEditModal: false,
      };
    default:
      return state;
  }
};

export default slAccountsPageReducer;
